import initialState from './state';
import { GET_PURCHASE_DETAILS_ERROR, GET_PURCHASE_DETAILS_LOADING, GET_PURCHASE_DETAILS_SUCCESS } from './types';

export const purchaseDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PURCHASE_DETAILS_LOADING:
      return {
        ...state,
        purchaseDetailsRequestStatus: {
          ...state.purchaseDetailsRequestStatus,
          isLoading: true,
          isError: false
        }
      };
    case GET_PURCHASE_DETAILS_SUCCESS:
      return {
        ...state,
        purchaseDetailsRequestStatus: {
          ...state.purchaseDetailsRequestStatus,
          isLoading: false,
          isError: false
        },
        purchaseDetails: action.purchaseDetails
      };
    case GET_PURCHASE_DETAILS_ERROR:
      return {
        ...state,
        purchaseDetailsRequestStatus: {
          ...state.purchaseDetailsRequestStatus,
          isLoading: false,
          isError: true
        },
        purchaseDetails: {
          ...state.purchaseDetails,
          error: action.error
        }
      };
    default:
      return state;
  }
};
